export type SilenceDurationUnit = "minutes" | "hours" | "days";

const MINUTES_PER_UNIT: Record<SilenceDurationUnit, number> = {
  minutes: 1,
  hours: 60,
  days: 24 * 60,
};

export function silenceDurationToMinutes(
  amount: number,
  unit: SilenceDurationUnit,
): number {
  return Math.round(amount * MINUTES_PER_UNIT[unit]);
}

export function silenceDurationFromMinutes(minutes: number): {
  amount: number;
  unit: SilenceDurationUnit;
} {
  const normalized = Number.isFinite(minutes) && minutes > 0 ? minutes : 60;
  if (normalized % MINUTES_PER_UNIT.days === 0) {
    return { amount: normalized / MINUTES_PER_UNIT.days, unit: "days" };
  }
  if (normalized % MINUTES_PER_UNIT.hours === 0) {
    return { amount: normalized / MINUTES_PER_UNIT.hours, unit: "hours" };
  }
  return { amount: normalized, unit: "minutes" };
}

export function validSilenceDuration(minutes: number): boolean {
  return Number.isInteger(minutes) && minutes >= 1 && minutes <= 30 * 24 * 60;
}
